import React, { useEffect, useState } from "react";
import PageTableLayout from "../../components/Pagetablelayout";
import axios from "axios";
import { Space, Button, Modal, Form, Input, Select, Popconfirm } from "antd";

export default function TagsPage() {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingTag, setEditingTag] = useState(null);
  const [form] = Form.useForm();

  const token = localStorage.getItem("jwt");
  const API_BASE = process.env.REACT_APP_API_URL || "https://mdgholidaydreams.com/api";

  const headersWithAuth = (extra = {}) =>
    token ? { Authorization: `Bearer ${token}`, ...extra } : { ...extra };

  const fetchTags = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/tags/`, {
        headers: headersWithAuth(),
      });
      const data = Array.isArray(res.data) ? res.data : res.data?.data ?? [];
      setTags(data.map(t => ({ ...t, active: Number(t.active) })));
    } catch (err) {
      console.error("Fetch tags failed:", err.response?.data ?? err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const handleAdd = () => {
    setEditingTag(null);
    form.resetFields();
    form.setFieldsValue({ active: 1 });
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingTag(record);
    form.setFieldsValue({
      name: record.name,
      active: Number(record.active),
    });
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      // Normalize values
      const payload = {
        name: values.name,
        active: Number(values.active ?? 1),
      };

      console.log("Tag payload being sent:", payload);

      if (editingTag) {
        // Use trailing slash to avoid redirect that drops body
        await axios.put(`${API_BASE}/tags/${editingTag.id}/`, payload, {
          headers: headersWithAuth({ "Content-Type": "application/json" }),
        });
      } else {
        await axios.post(`${API_BASE}/tags/`, payload, {
          headers: headersWithAuth({ "Content-Type": "application/json" }),
        });
      }

      form.resetFields();
      setIsModalVisible(false);
      setEditingTag(null);
      fetchTags();
    } catch (err) {
      console.error("Save tag failed:", err.response?.data ?? err);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingTag(null);
    form.resetFields();
  };

  const columns = [
    { title: "Tag Name", dataIndex: "name", key: "name" },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: active => (Number(active) === 1 ? "Active" : "Inactive"),
    },
    { title: "Created By", dataIndex: "created_by", key: "created_by" },
    { title: "Updated By", dataIndex: "updated_by", key: "updated_by" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleEdit(record)}>Edit</Button>

          <Popconfirm
            title="Deactivate this tag?"
            okText="Yes"
            cancelText="No"
            onConfirm={async () => {
              try {
                await axios.patch(`${API_BASE}/tags/${record.id}/`, {}, {
                  headers: headersWithAuth(),
                });
                fetchTags();
              } catch (err) {
                console.error("Deactivate tag failed:", err.response?.data ?? err);
              }
            }}
          >
            <Button danger>Deactivate</Button>
          </Popconfirm>

          <Popconfirm
            title="Delete this tag?"
            okText="Yes"
            cancelText="No"
            onConfirm={async () => {
              try {
                await axios.delete(`${API_BASE}/tags/${record.id}/`, {
                  headers: headersWithAuth(),
                });
                fetchTags();
              } catch (err) {
                console.error("Delete tag failed:", err.response?.data ?? err);
              }
            }}
          >
            <Button danger>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <PageTableLayout
        breadcrumb={["Admin", "Tags"]}
        title="Manage Tags"
        addButtonLabel="Add Tag"
        onAdd={handleAdd}
        columns={columns}
        dataSource={tags}
        loading={loading}
        onRefresh={fetchTags}
      />

      <Modal
        title={editingTag ? "Edit Tag" : "Add New Tag"}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Tag Name"
            rules={[{ required: true, message: "Please enter a tag name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="active"
            label="Status"
            rules={[{ required: true, message: "Please select status" }]}
          >
            <Select placeholder="Select status">
              <Select.Option value={1}>Active</Select.Option>
              <Select.Option value={0}>Inactive</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
